import { AppConfig } from "../config";

export const identity = AppConfig.identity
